<template>
  <div class="hello">
    <van-nav-bar
      title="用户注册"
      left-text="登录"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <van-icon name="arrow-left" color="Gray" size="18" />
      </template>
    </van-nav-bar>
  </div>
</template>
<script>
export default {
  methods: {
    onClickLeft() {
      // 成功通知
      this.$notify({ type: "success", message: "后退" });
      this.$router.go(-1);
      // Notify({type:"success",message:"后退"});
    },
    onClickRight() {
      // 危险通知
      this.$toast("失败文案");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
